<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>
<div class="row">
  <div class="col-12">

    <app-card cardTitle="Ordens em Andamento" cardClass="table-card" blockClass="p-0" [options]="false">
      <div class="form-group col-4">
        <label for="exampleInputEmail1">Filtro</label>
        <input type="text" class="form-control" [(ngModel)]="query" placeholder="Entre com seu Filtro">

      </div>
      <div class="table-responsive">
       
          <table class="table table-hover m-b-0">
            <thead>
              <tr>

                <th>O.P.</th>
                <th>Produto</th>
                <th>Máquina</th>
                <th>Previsto</th>
                <th>Produzido</th>
                <th>%</th>
               
                <th>Ver</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let ap of apontamentos  | fullTextSearch:query">
                <td>
                  <h6 class="m-0" *ngIf="ap.op_numero > 0" >{{ap.op_numero}}  </h6>
                  <h6 class="m-0" *ngIf="ap.op_numero == 0" >{{ap.op_numero_avulso}} </h6>
                </td>
                <td>{{ap.produto}}</td>
                <td>{{ap.maquina}}</td>
                <td>{{ap.quantidadePrevista}}</td>
                <td>{{ap.quantidadeTotal}}</td>
                <td>
 
                 {{ ap.porcentagem}} %          
                    <div class="mt-1">
                      <ngb-progressbar height="6px" [value]="ap.porcentagem"></ngb-progressbar>
                    </div>
                </td>
               
                <td>
                  <button type="button" class="btn btn-icon btn-warning" (click)="ordemProducao(ap)">
                    <i class="feather icon-eye"></i>
                  </button>
                </td>
                <td>
                  <a href="javascript:" (click)="excluir(ap)">
                    <i class="feather icon-trash-2 ml-3 f-28 text-c-red"></i>
                  </a>
                </td>
              </tr>

            </tbody>
          </table>
     
      </div>
    </app-card>

  </div>
</div>
